export enum Enum {

    // For dropdown load
    Region = 1,
    Country = 2,
    LocationName = 3,
    KeyboardType = 4,
    BusinessCenter = 5,
    ProctorGroup = 6,
    State = 7,
    City = 8,
    TimeZone = 9,

    // Status
    StatusActive = 1,
    StatusPending = 2,
    StatusRetire = 3,
    StatusUnavailable = 4,

    // IdentityType starts (used to update the status-Active/Retire etc.)
    Koala = 1,
    Location = 2,
    IdentityType_Admin = 3,
    IdentityType_Exam = 4,
    // IdentityType ends

    // RoleType starts
    RoleTypeGlobalAdmin = 1,
    RoleTypeRegionalAdmin = 2,
    RoleTypeSiteAdmin = 3,
    // RoleType ends

    //status definition for pending id
    PendingStatusApprove = 5,
    PendingStatusReject = 6,
    //status definition for pending id ends

    // Used in Notification popup
    ExamExpiredStatus = 8,
    ExamUpcomingStatus = 7,

    // Proctor Team Lead User
    proctorTeamLead_Active = 0,
    proctorTeamLead_Retire = 1,

    //manage exam session record status
    proctor_Retain = 1,
    proctor_Release = 0,

    //exam-delivery-codes
    ExamDeliveryCodes = 11,
    AllExamsCodes = 10

}


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/utility/enum.enum.ts